import { render, staticRenderFns } from "./FormPreviewModal.vue?vue&type=template&id=770c3096"
import script from "./FormPreviewModal.vue?vue&type=script&lang=js"
export * from "./FormPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports